<template><div><h1 id="fremdadressen" tabindex="-1"><a class="header-anchor" href="#fremdadressen"><span>Fremdadressen</span></a></h1>
<p>Fremdadressen — Verwaltet Fremdadressen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Dient der Bearbeitung von Fremdadressen. Diese können gesucht werden wie in den Eigenadressen mit gehezu. Fremdadressen können auch mit Ereignissen versehen werden (automatisch über Filter oder manuell). Eine Bearbeitung der Adresse an sich ist nicht möglich.</p>
<p>Pfad: <code v-pre>Personen → Fremdadressen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>AdressNr</dt>
<dd>Personen-ID, eindeutiger Identifikator für jede einzelne Adresse, vom System vergeben</dd>
<dt>AdrTyp</dt>
<dd><span class="emphasis"><em>Adresstyp</em></span>, p für Privatadressen, f für Firmen-/Institutionadressen</dd>
<dt>SpAnTit</dt>
<dd><span class="emphasis"><em>Sprachcode</em></span>, 2-stellig, siehe Tabelle &quot;Sprachen&quot;, hinter dem ersten Sprachcode kann eine Alternativsprache eingegeben sein, welche in mehrsprachigen Selekts verwendet werden kann<br><span class="emphasis"><em>Anredecode</em></span>, 1-stellig, siehe Tabelle &quot;Anrede-Code&quot;<br><span class="emphasis"><em>Titel</em></span>, Titel der Person, siehe Tabelle &quot;Titel und akad. Grad&quot;</dd>
<dt>Quelle</dt>
<dd>Personenquelle, wird beim Einlesen von Adressen durch den Systemverwalter vergeben. Dient der Identifikation der Herkunft einer Adresse.</dd>
<dt>Geb</dt>
<dd>Geburtsdatum, es besteht aus 3 Feldern:<br>2-stelliger TAG<br>2-stelliger MONAT<br>4-stelliges JAHR</dd>
<dt>Vorname</dt>
<dd>Vorname</dd>
<dt>Nachname</dt>
<dd>Nachname</dd>
<dt>Firma</dt>
<dd>Firmenname, wird nur für Firmenadressen verwendet</dd>
<dt>AdZusatz</dt>
<dd>Adresszusatz, ergibt eine zweite Zeile in der Adresse für den Adressnamen, wird v.a. für Firmenadressen verwendet</dd>
<dt>Strasse</dt>
<dd>Strasse, 3-teilig: 1. Feld = Strassenname, 2. Feld = Hausnummer, 3. Feld = alphanumerischer Hausnummerzusatz (z.B. Rütistrasse 1b)</dd>
<dt>Postfach</dt>
<dd>Postfachinformationen</dd>
<dt>L.PlzOrt</dt>
<dd>Land, Postleitzahl, Ort</dd>
<dt>Telefon</dt>
<dd>Anzeige der Telefonnummer</dd>
<dt>Fax</dt>
<dd>Anzeige der Faxnummer</dd>
<dt>Bemerkungen</dt>
<dd>(Feld ohne Bezeichnung), 48-stellig, alphanumerisch, 1 Zeile</dd>
<dt>FremdDB</dt>
<dd>Anzeige der Personenquelle durch Fremddatenbanknummer und in Klammer die Quelle.</dd>
<dt>Merkmal</dt>
<dd>Anzeige allfälliger Merkmale zur Adresse</dd>
<dt>Ereignis</dt>
<dd>Anzeige bereits erfasster Ereignisse zur Adresse, 4-stellig pro Ereignis. Sortierung nach Datum absteigend.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="fremdadresse-anonymisieren" tabindex="-1"><a class="header-anchor" href="#fremdadresse-anonymisieren"><span>Fremdadresse anonymisieren</span></a></h3>
<p>Diese Funktion löscht die Fremdadresse und verschiebt die Ereignisse zu der Freamdadresse &quot;Anonym (Sammeladresse)&quot;. Wenn eine Fremdadresse bereits in die Haus-DB übernommen worden ist, erscheint eine Meldung.</p>
<h3 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h3>
</div></template>


